import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Subject } from 'rxjs';
import * as _ from 'underscore';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver';

export class PendingRequest {
  url: string;
  method: string;
  options: any;
  data: any;
  params: any;
  subscription: Subject<any>;

  constructor(
    url: string,
    method: string,
    options: any,
    data: any,
    params: any,
    subscription: Subject<any>
  ) {
    this.url = url;
    this.method = method;
    this.options = options;
    this.data = data;
    this.params = params;
    this.subscription = subscription;
  }
}

@Injectable({
  providedIn: 'root'
})
export  class DataService {
  private requests$ = new Subject<any>();
  private queue: PendingRequest[] = [];
  req: HttpRequest<any>;
  apiUrl = environment.apiUrl;
  loading = false;

  constructor(private httpClient: HttpClient) {
    this.requests$.subscribe(request => this.execute(request));
  }

  downloadFile(url, name, blob = true) {
    const mime = require('mime');
    if (blob) {
      this.invoke(url, 'get', null, null, { reportProgress: true,
        observe: 'events', responseType: 'blob' }).subscribe(
        res => {
          const blobData: Blob = new Blob([res], { type: res.type });
          saveAs(blobData, `${name}.${mime.getExtension(res.type)}`);
        },
        err => {
          console.error(err);
        }
      );
    } else {
      saveAs(url, `${name}.${mime.getExtension(url)}`);
    }
  }

  parseParams(params) {
    const returnParams = {};
    for (const key in params) {
      if (params[key] !== null) {
        if (key === 'date_to' || key === 'date_from') {
          returnParams[key] = moment(params[key]).format('YYYY-MM-DD');
        } else {
          returnParams[key] = params[key];
        }

      }
    }
    return returnParams;
  }

  /** Call this method to add your http request to queue */
  invoke(url, method = 'get', params = null, data = null, options = null, apiUrl = this.apiUrl) {
    const fullUrl = apiUrl + url;
    return this.addRequestToQueue(fullUrl.replace('tech//', 'tech/'), method, this.parseParams(params), data, options);
  }

  private execute(requestData) {
    this.loading = true;
    let responseType: 'arraybuffer' | 'blob' | 'json' | 'text' = 'json';
    if (requestData.options && requestData.options.responseType) {
      responseType = requestData.options.responseType ;
    }

    this.httpClient.request(requestData.method, requestData.url, {
      headers: (requestData.options && requestData.options.headers) ? requestData.options.headers : null,
      params: requestData.params,
      body: requestData.data,
      responseType: responseType
    }).subscribe(
      res => {
        const sub = requestData.subscription;
        sub.next(res);
        this.queue.shift();
        this.loading = false;
        this.startNextRequest();
      },
      err => {
        const sub = requestData.subscription;
        sub.error(err);
        this.queue.shift();
        this.loading = false;
        this.startNextRequest();
      }
    );
  }

  private addRequestToQueue(url: string, method: string, params, data, options) {
    const sub = new Subject<any>();
    const apiUrl =  `${url}`;
    const request = new PendingRequest(apiUrl, method, options, data, params, sub);
    this.queue.push(request);
    if (this.queue.length === 1) {
      this.startNextRequest();
    }
    return sub;
  }

  private startNextRequest() {
    // get next request, if any.
    if (this.queue.length > 0) {
      this.execute(this.queue[0]);
    }
  }
}
